exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".eway-field {\n  max-height: 44px;\n  overflow: hidden;\n  border-radius: 4px;\n  border: 1px solid #dadada;\n}\n.eway-field-error {\n  border: 1px solid red;\n}\n", ""]);
